import React from 'react';
import Header from './components/Header';
import HeroBanner from './components/HeroBanner';
import AIApp from './components/AIApp';
import './index.css';
import Footer from './components/Footer';
import Feedback from './components/Feedback';

function App() {
  return (
    <div className="min-h-screen bg-primary-50 text-gray-800 font-inter">
      <Header />
      <HeroBanner />
      <AIApp />
      <Feedback />
      <Footer />
    </div>
  );
}

export default App;